import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import Colors from "../../common/Colors";
import Switch from "../../components/Switch";
import Modal from "../../components/Modal";
import { padding } from "@mui/system";

import { Box } from "@mui/material";

import assets from "../../common/assets";

import Floors from "./Components/Floors";
import Tables from "./Components/Tables";
import Toast from "../../components/Toast";

class DineInScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: null,
      catagoriesWithMenu: [],
      search: "",
      searchResult: [],
      tables: [],
      selectTablePopup: true,
      selectedTable: {},
      cart: [],
      paidBy: "cash",
      checkInDate: null,
      checkOutDate: null,
      kotPrintInProgress: false,
      billPrintInProgress: false,
      subTotal: 0,
      discount: 0,
      gst: 0,
      gstPer: 0.18,
      total: 0,
      floors: [],
      cartMode: "add", //add  kot
      kot: [],
      toast:{
        show: false,
        message: "",
        type: "success",
      }
    };
  }
  componentDidMount() {
    this.getHotelCatagoriesWithMenu();
    // this.listAllTablesForHotel();

    // this.getUserData();
    // this.getAllAvailablePermissions();

    this.getFloors();
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };

  getFloors = async (noAfter = false) => {
    const { status, message, hotelFloors } = await API(
      this,
      "get",
      URL_PATH.floorList(this.props.selectedHotelId.id)
    );
    if (status == "success") {
      this.setState({ floors: hotelFloors });
      if (hotelFloors.length > 0) {
        if (noAfter) return;

        this.getTables(hotelFloors[0].id);
      }
    } else {
      this.showToast(message, "error");
    }
  };

  getTables = async (floorId) => {
    if (floorId != 0)
      if (!floorId) return console.log("floor id is invalid" + floorId);

    this.setState({ selectedFloorId: floorId });

    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.listTable(floorId)
    );
    if (status == "success") {
      data.data = data.data.filter((item) => {
        // if (item.table_status == 1 && item.vacant_type == "joined") return null;
        const tableStatus = item.table_status ?? 1;
        item.table_status = tableStatus;
        return item;
      });

      this.setState({ tables: data.data });
    }
  };

  getHotelCatagoriesWithMenu = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getHotelCatagoriesWithMenu(this.props.selectedHotelId.id)
    );
    if (status == "success") {
      this.setState({ catagoriesWithMenu: data });
    } else {
      this.toast({
        
        message: message,
        type: "error",
      });
    }
  };

  create = async () => {
    //validate all input fields conatining value

    var formdata = new FormData(document.getElementById("hotelForm"));

    const rawMaterial = "";

    formdata.append("rawMaterial", JSON.stringify(rawMaterial));
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.createInventoryInvoice,
      formdata
    );
    if (status == "success") {
      this.showToast(message, "success");
this.props.history.push(routes.admin.invoices.list);
    } else {
      this.showToast(message, "error");
    }
  };

  search = async () => {
    try {
      clearTimeout(this.searchBounce);
    } catch (e) {}

    this.searchBounce = setTimeout(async () => {
      const url = URL_PATH.hotelMenuSearch(
        this.props.selectedHotelId.id,
        this.state.search
      );

      const { status, message, data } = await API(this, "get", url);
      if (status == "success") {
        console.log("data", data);
        this.setState({ searchResult: data });
      } else {
        this.showToast(message, "error");
      }
    }, 500);
  };

  addToCart = (item) => {
    //
    let cart = this.state.cart;
    let index = cart.findIndex((x) => x.id == item.id);
    if (index == -1) {
      cart.push({ ...item, quantity: 1 });
    } else {
      cart[index].quantity++;
    }

    this.setState({ cart }, () => {
      this.calculates();
    });
  };

  removeFromCart = (item) => {
    let cart = this.state.cart;
    let index = cart.findIndex((x) => x.id == item.id);
    if (index != -1) {
      cart.splice(index, 1);
    }
    this.setState(
      {
        cart,
      },
      () => this.calculates()
    );
  };

  saveOrder = async (savePrompt = true) => {
    let cart = this.state.cart;
    let order = {
      hotel_id: this.props.selectedHotelId.id,
      table_id: this.state.selectedTable.id,
      order_details: cart,
      paid_by: this.state.paidBy,
      check_in_date: this.state.checkInDate,
      check_out_date: this.state.checkOutDate,
    };

    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.createCustomBilling,
      order
    );
    if (status == "success") {
      if (savePrompt)
        this.showToast(message, "success");
      this.props.history.push(routes.admin.invoices.list);

      this.setState({
        orderId: data.order_id,
      });
    }
  };

  renderKot = () => {
    const cart = this.state.cart;
    return (
      <Box
        id={"kot"}
        className=" col-lg-3 p-3"
        style={{
          display: "none",
          margin: 10,
          backgroundColor: Colors.pageBgColor,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Box>
            <h4 style={{ textAlign: "center" }}>
              {this.props.selectedHotelId.hotel_name}
            </h4>
          </Box>
          <Box
            style={{
              paddingBottom: "5px",
              borderBottom: "1px solid black",
              marginBottom: "5px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box
              style={{
                //horizontally center elements
                textAlign: "center",
              }}
            >
              {this.state.orderId}
              <br />
              Order Id
              {"Dine In" == "dinein" ? "Dine In" : "Take Away"}
            </Box>
            <Box
              style={{
                textAlign: "center",
              }}
            >
              KOT
            </Box>
            <Box
              style={{
                //horizontally center elements
                textAlign: "center",
              }}
            >
              {moment().format("HH:mm")}
              <br />
              Time
            </Box>
          </Box>
          {/* customer */}
          {/* <h5
                        className="card-subtitle "
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            marginBottom: "5px",
                        }}
                    >
                        <span> {item.hotel_order.user.name}</span>
                        <span> {item.hotel_order.user.mobile}</span>
                    </h5> */}

          {/* table no */}

          <Box className="card-subtitle" style={{ textAlign: "center" }}>
            {this.state.selectedTable.table_no}
          </Box>

          {/* menus */}
          <Box
            style={{
              marginTop: "5px",
              paddingTop: "5px",
              borderTop: "1px solid black",
            }}
          >
            <Box
              style={{
                textAlign: "center",
                borderBottom: "1px solid black",
              }}
            >
              Order Summary
            </Box>
            <table width="100%">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Item</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item, index) => (
                  <tr
                    style={{
                      borderBottom: "1px dotted black",
                    }}
                  >
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td> {item.menu_name}</td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {item.quantity}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>
    );
  };
  renderBill = () => {
    const cart = this.state.cart;
    return (
      <Box
        id={"bill"}
        className=" col-lg-3 p-3"
        style={{
          margin: 10,
          backgroundColor: Colors.pageBgColor,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Box style={{ borderBottom: "solid 2px black" }}>
            <h4 style={{ textAlign: "center", fontWeight: "bold" }}>
              {this.props.selectedHotelId.hotel_name}
            </h4>
            <h6 style={{ textAlign: "center" }}>
              {this.props.selectedHotelId.address}
            </h6>
          </Box>
          <Box
            style={{
              borderBottom: "2px solid black",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              alignContent: "center",
              padding: "5px 0px",
            }}
          >
            <Box
              style={{
                //horizontally center elements
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              #{this.state.orderId}
            </Box>
            <Box
              style={{
                //horizontally center elements
                textAlign: "center",
              }}
            >
              {moment().format("YYYY-MM-DD hh:mm A")}
            </Box>
          </Box>
          {/* customer */}
          {/* <h5
                        className="card-subtitle "
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            marginBottom: "5px",
                        }}
                    >
                        <span> {item.hotel_order.user.name}</span>
                        <span> {item.hotel_order.user.mobile}</span>
                    </h5> */}

          {/* table no */}

          {/* <Box
                        className="card-subtitle"
                        style={{ textAlign: "center" }}
                    >
                        {this.state.selectedTable.table_no}
                    </Box> */}

          {/* menus */}

          <table width="100%">
            <thead>
              <tr
                style={{
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  padding: "3px 0px",
                }}
              >
                <th>Items</th>
                <th>Rate</th>
                <th>Q</th>
                <th>₹₹</th>
              </tr>
            </thead>
            <tbody>
              {cart.map((item, index) => (
                <tr
                  style={{
                    borderBottom: "1px solid black",
                  }}
                >
                  <td> {item.menu_name}</td>
                  <td>{item.menu_price}</td>
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {item.quantity}
                  </td>
                  <td>₹{item.menu_price * item.quantity}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Total gst spc discount  */}
          <Box
            style={{
              borderBottom: "solid 2pz black",
            }}
          >
            {/* Total */}
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              {/* Subtotal */}
              <Box>Subtotal</Box>
              <Box>₹{this.state.subTotal}</Box>
            </Box>
            {/* GST */}
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              {/* Subtotal */}
              <Box>GST(%)</Box>
              <Box>{this.state.gstPer}%</Box>
            </Box>

            {/* SPC */}
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              <Box>Spe. Dis.(₹)</Box>
              <Box>₹0</Box>
            </Box>
          </Box>
          {/* Total and paid with */}

          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: "5px",
              fontWeight: "bold",
            }}
          >
            <Box>Total</Box>
            <Box>₹{this.state.total}</Box>
          </Box>
          <Box style={{ textAlign: "center" }}>(Paid with UPI)</Box>
          <hr />
          <Box style={{ textAlign: "center" }}>
            Thank you!
            <br />
            Please Visist Us Again!
          </Box>
        </Box>
      </Box>
    );
  };

  printKot = async (bill = false) => {
    await this.saveOrder(false);

    if (bill == false) await this.setState({ kotPrintInProgress: true });
    else await this.setState({ billPrintInProgress: true });

    let printContents = document.getElementById(
      bill ? "bill" : "kot"
    ).innerHTML;

    // document.getElementById("kot").style.display = "block";

    var windowUrl = "about:blank";
    var uniqueName = new Date();
    var windowName = "Print" + uniqueName.getTime();

    var printWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,width=0,height=0"
    );

    printWindow.document.write(printContents);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();

    // document.getElementById("kot_action_" + item.id).style.display = "flex";
    // document.getElementById("kot_" + item.id).style.margin = "10px";
    // document.getElementById("kot_logo_" + item.id).style.display = "none";

    this.setState({ kotPrintInProgress: false, billPrintInProgress: true });
  };

  calculates = () => {
    const subtotal = this.state.cart.reduce(
      (a, b) => a + b.menu_price * b.quantity,
      0
    );
    const gst = subtotal * (this.state.gstPer / 100);
    const total = subtotal + gst;

    this.setState({
      subTotal: subtotal,
      gst: gst,
      total: total,
    });
  };

  decreaseQuantity = (item) => {
    let cart = this.state.cart;
    let index = cart.findIndex((x) => x.id == item.id);
    if (index != -1) {
      if (cart[index].quantity == 1) return cart.splice(index, 1);

      cart[index].quantity--;
    }
    this.setState(
      {
        cart,
      },
      () => this.calculates()
    );
  };

  deSelectTable = (after = null) => {
    this.setState(
      {
        selectedTableId: 0,
        selectedCatagoryId: -1,
        selectedTableNo: "",
        selectedTableVacant: false,
        SelectedTableOrderData: {},
        user: {},
        addItems: false,
        selectedTable: {},
      },
      () => {
        if (after) after();
      }
    );
  };

  renderFloor = ({ item, index }) => {
    const { id, call_waiter = 0 } = item;
    console.log("render floor", item);

    return (
      <Box
        onClick={() => {
          this.deSelectTable(() => {
            const { floors } = this.state;

            floors[index].call_waiter = 0;

            this.setState(
              {
                selectedFloorId: item.id,
                tables: [],
                floors,
              },
              () => this.getTables(item.id)
            );
          });
        }}
        style={{
          padding: "5px 15px",
          margin: "2px 5px",
          borderRadius: 3,
          backgroundColor:
            this.state.selectedFloorId == item.id ? Colors.btnColor : "#fff",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <span style={{ color: "#000" }}>{item.floor_no}</span>
        {call_waiter == 1 && (
          <Box
            style={{
              position: "absolute",
              top: 2,
              right: 2,
              width: 10,
              height: 10,
              borderRadius: 5,
              backgroundColor: Colors.blueColor,
            }}
          ></Box>
        )}
      </Box>
    );
  };

  getWidth = () => {
    return window.innerWidth;
  };

  getTableOrders = async (table) => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getTableActiveOrders(table.id ?? table)
    );

    if (status == "success") {
      this.setState({
        user: data.user ?? {},
        kot: data.kot,
        selectedTableVacant: true,
        SelectedTableOrderData: data,
      });
    } else {
      this.setState({
        selectedTableVacant: false,
      });
    }
  };

  renderTable = (item, index) => {
    const {
      call_waiter,
      created_at,
      deleted_at,
      hotel_floor_id,
      id,
      table_capacity,
      table_no,
      table_status,
      type,
      updated_at,
      vacant_id,
      vacant_type,
    } = item;

    return (
      <button
        key={index}
        style={{
          // width: (this.getWidth() - 20 - 4 - 10 - 4) / 5,
          minWidth: 50,
          minHeight: 50,
          borderRadius: 3,
          backgroundColor:
            this.state.selectedTableId == id
              ? Colors.btnColor
              : table_status == 1
              ? call_waiter == 1
                ? Colors.redColor
                : Colors.greenColor
              : Colors.transparent,

          margin: 2,
          borderWidth: 1,
          borderRadius: 5,
          borderColor:
            this.state.selectedTableId == id || table_status == 0
              ? Colors.btnColor
              : "transparent",
          position: "relative",
          cursor: "pointer",
        }}
        onClick={() => {
          this.deSelectTable();
          this.setState(
            {
              selectedTable: item,
              selectedTableId: id,
              selectedTableNo: table_no,
            },
            () => this.getTableOrders(item)
          );
        }}
      >
        <span
          style={{
            color: this.state.selectedTableId == id ? "black" : "white",

            fontSize: 12,
          }}
        >
          {table_no ?? id}
        </span>

        {call_waiter == 1 && (
          <img
            src={assets.callwaiter}
            alt="Call Waiter"
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              width: 15,
              height: 15,
              position: "absolute",
              top: 5,
              right: 5,
              tintColor: Colors.white,
            }}
          />
        )}
      </button>
    );
  };

  RenderItems = ({ item, index }) => {
    const {
      id,
      kot_id,
      hotel_menu_id,
      item_menu_name,
      item_quantity,
      hotel_menu_price,
    } = item;

    return (
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          alignSelf: "center",
          padding: "10px",
          paddingBottom: "20px",
          alignItems: "flex-start",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              backgroundColor: "#16232C",
              height: "30px",
              width: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* numbers */}
            <p
              style={{
                color: "white",
                fontSize: "16px",
                margin: 0,
              }}
            >
              {index + 1}
            </p>
          </Box>
          <Box style={{ marginLeft: "10px" }}>
            <p style={{ fontSize: "16px" }}>
              {item_quantity} x {item_menu_name}
            </p>
          </Box>
        </Box>

        <Box style={{ marginTop: "2px" }}>
          <p style={{ color: "#3498db", fontSize: "15px" }}>
            {hotel_menu_price}
          </p>
        </Box>
      </Box>
    );
  };

  OrderDetails = () => {
    const { SelectedTableOrderData, user } = this.state;

    const { id, user_id, order_grand_total, order_payment_status } =
      SelectedTableOrderData;
    const { name = "Unknown", email = null, mobile = null } = user;

    return (
      <Box className="container">
        <Box className="order-details">
          <p>Order ID: {id}</p>
          <p>
            Customer: {name} - {mobile}
          </p>
        </Box>
        <Box className="kot-list">
          {this.state.kot.reverse().map((item, index) => {
            const statusColor =
              item.status == "pending"
                ? "blue"
                : item.status == "completed"
                ? "green"
                : item.status == "cancelled"
                ? "red"
                : "default";

            const order_time =
              "Order Time: " + moment(item.created_at).format("hh:mm A");
            const order_time_ago = moment(item.created_at).fromNow();

            return (
              <Box key={item.id} className="kot-item">
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <span>KOT ID : {item.id}</span>
                  <button
                    className={`status-button ${statusColor}`}
                    onClick={() => {
                      this.changeKOTStatus(item, index);
                    }}
                  >
                    {item.status}
                  </button>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <span>{order_time}</span>
                  <span>{order_time_ago}</span>
                </Box>
                <Box className="item-list">
                  {item.kot_items.map((item, index) =>
                    this.RenderItems({ item, index })
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>

        <Box className="action-buttons">
          {this.state.selectedTable.call_waiter == 1 && (
            <button
              className="waiter-button"
              onClick={() => this.waiterVisited()}
            >
              <span>Waiter Sent</span>
              <img
                src={"https://cdn-icons-png.flaticon.com/512/62/62649.png"}
                alt="Waiter Icon"
              />
            </button>
          )}

          <button
            className="add-items-button"
            onClick={() => this.startOrder()}
          >
            <span>Add Items</span>
          </button>

          {/* {user_id == 0 && ( */}
          <button className="checkout-button" onClick={() => this.checkout(id)}>
            <span>Checkout</span>
          </button>
          {/* )} */}
        </Box>
      </Box>
    );
  };

  render() {
    return (
      <Box className="container-fluid">
        <Box className="d-flex flex-row">
          {/* left side tables search catagory menu*/}
          <Box
            style={{
              flex: 75,
              display: "flex",
              border: "1px solid black",
              flexDirection: "column",
              // marginRight: "10px",
            }}
          >
            {/* Floors */}

            {/* <Floors
              data={this.state.floors}
              onClick={() => {
                this.deSelectTable((item,index) => {
                  const { floors } = this.state;

                  floors[index].call_waiter = 0;

                  this.setState(
                    {
                      selectedFloorId: item.id,
                      tables: [],
                      floors,
                    },
                    () => this.getTables(item.id)
                  );
                });
              }}
            /> */}

            {/* <Box
              style={{
                display: "flex",
                flexDirection: "row",
                // justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              {this.state.floors.map((item, index) => (
                <React.Fragment key={index}>
                  {this.renderFloor({ item, index })}
                </React.Fragment>
              ))}
            </Box> */}

            {/* active floor tables */}
            <Box>
              {this.state.tables.length > 0 ? (
                this.state.tables.map((item, index) => (
                  <React.Fragment key={index}>
                    {this.renderTable(item, index)}
                  </React.Fragment>
                ))
              ) : (
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 100,
                  }}
                >
                  No Tables Found
                </Box>
              )}
            </Box>

            {/* search catagory menu*/}
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box class="input-group flex" style={{ flex: 1 }}>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter the product name"
                  value={this.state.search}
                  onChange={(e) => {
                    this.setState(
                      {
                        search: e.target.value,
                      },
                      () => {
                        this.search();
                      }
                    );
                  }}
                />
                <Box class="input-group-append">
                  <button class="btn btn-secondary" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </Box>
              </Box>

              <Box
                style={{
                  float: "right",
                  cursor: "pointer",
                  display: "flex",
                  backgroundColor: Colors.primary,
                  color: "black",
                  alignItems: "center",
                  alignContent: "center",
                  borderRadius: 2,
                  padding: "5px 10px",
                }}
                className="mx-2"
                onClick={() => {
                  this.setState({ selectTablePopup: true });
                }}
              >
                <i
                  class="fa fa-table"
                  style={{
                    color: "black",
                    marginRight: "10px",
                  }}
                ></i>{" "}
                Change Table
              </Box>
            </Box>

            {/* catagory menu */}
            <Box
              style={{
                maxHeight: "85vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              className="d-flex flex-column"
            >
              {this.state.search != "" && (
                <Box className="d-flex flex-column">
                  {/* //search result */}
                  <Box
                    className="row"
                    style={{
                      padding: "5px 10px",
                      // backgroundColor: Colors.primary,
                      color: "white",
                      borderRadius: 2,
                      margin: "5px",
                    }}
                  >
                    Search Result: {this.state.search}
                  </Box>
                  <Box className="row">
                    {this.state.searchResult.map((item, index) => {
                      return (
                        <Box className="col-3 pl-0 pr-0">
                          <Box
                            onClick={() => {
                              this.addToCart(item);
                            }}
                            style={{
                              padding: "5px 7px",
                              border: "1px solid rgba(0,0,0,0.3)",
                              cursor: "pointer",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              margin: "5px",
                              backgroundColor: Colors.pageBgColor,
                            }}
                          >
                            <span>{item.menu_name}</span>
                            <span>{item.menu_price}</span>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}

              <Box className="d-flex flex-row flex-wrap">
                {this.state.catagoriesWithMenu.map((item, index) => {
                  if (item.hotel_menu.length == 0) return null;
                  return (
                    <Box className="col-3 pl-0 pr-0 my-2">
                      <Box
                        style={{
                          backgroundColor: Colors.pageBgColor,
                          margin: "5px",
                          border: `1px solid ${Colors.primary}`,
                          //match the height to parent
                          height: "100%",
                          borderRadius: "4px",
                        }}
                        className=""
                      >
                        {/* category name */}
                        <Box
                          style={{
                            backgroundColor: Colors.secondary,
                            color: Colors.white,
                            padding: "5px",
                          }}
                        >
                          {item.category_name}
                        </Box>
                        {/* menus */}
                        <Box style={{}}>
                          {item.hotel_menu.map((item, index) => {
                            return (
                              <Box
                                onClick={() => {
                                  this.addToCart(item);
                                }}
                                style={{
                                  padding: "5px 7px",
                                  border: "1px solid rgba(0,0,0,0.3)",
                                  cursor: "pointer",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>{item.menu_name}</span>
                                <span>{item.menu_price}</span>
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>

          {/* right side bill*/}
          <Box
            style={{
              display: "flex",
              flex: 25,
              // minHeight: "100vh",
              maxHeight: "85vh",
              overflowY: "auto",
              backgroundColor: Colors.pageBgColor,
              // padding: "10px",
              margin: "0px 10px",
              flexDirection: "column",
              borderRadius: "4px",
              border: `1px solid ${Colors.primary}`,
            }}
          >
            {/* //table no */}

            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box
                style={{
                  padding: "10px",
                  backgroundColor: Colors.primary,
                  color: "black",
                  textAlign: "center",
                }}
              >
                Table No. {this.state.selectedTable.table_no}
              </Box>

              <Box
                style={{
                  padding: "10px",
                }}
              >
                {/* Add Items */}
                <button
                  style={{
                    padding: "7px 10px",
                    backgroundColor:
                      this.state.cartMode == "add"
                        ? Colors.primary
                        : Colors.greytxtcolor,
                    color: "black",
                    borderWidth: "0px",
                    borderRadius: "15px 0px 0px 15px",
                  }}
                  onClick={() => {
                    this.setState({
                      cartMode: "add",
                    });

                    this.setState({
                      cart: [],
                    });
                  }}
                >
                  Add Items
                </button>

                {/* //view cart */}
                <button
                  style={{
                    padding: "7px 10px",
                    backgroundColor:
                      this.state.cartMode == "kot"
                        ? Colors.primary
                        : Colors.greytxtcolor,
                    color: "black",
                    borderRadius: "0px 15px 15px 0px",
                    borderWidth: "0px",
                  }}
                  onClick={() => {
                    this.setState({
                      cartMode: "kot",
                    });
                  }}
                >
                  View KOT
                </button>
              </Box>
            </Box>

            {/* //cart */}

            <Box
              style={{
                padding: "15px",
              }}
            >
              {/* Add new menu */}

              {this.state.cartMode == "add" && (
                <table className="table table-borderless">
                  <thead>
                    <tr
                      style={{
                        borderBottom: "1px solid black",
                      }}
                    >
                      <th>Item</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Total</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      borderBottom: "1px solid black",
                    }}
                  >
                    {this.state.cart.map((item, index) => {
                      return (
                        <tr>
                          <td>{item.menu_name}</td>
                          <td>
                            {/* rupee currency symbol    */}
                            <span>&#8377;</span>

                            {item.menu_price}
                          </td>

                          <td
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              alignContent: "center",
                            }}
                          >
                            <Box
                              onClick={() => {
                                this.decreaseQuantity(item);
                              }}
                            >
                              -
                            </Box>
                            <Box
                              style={{
                                width: "30px",
                                textAlign: "center",
                                padding: "5px",
                                border: "1px solid rgba(0,0,0,0.3)",
                                backgroundColor: Colors.rootBgColor,
                              }}
                            >
                              {item.quantity}
                            </Box>
                            <Box
                              onClick={() => {
                                this.addToCart(item);
                              }}
                            >
                              +
                            </Box>
                          </td>

                          <td>{item.menu_price * item.quantity}</td>
                          <td
                            onClick={() => {
                              this.removeFromCart(item);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}

              {/* kot list */}

              {this.state.cartMode == "kot" &&
                this.state.selectedTableVacant &&
                this.OrderDetails()}

              {/* Subtotal */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box>Subtotal</Box>
                <Box>{this.state.subTotal}</Box>
              </Box>
              {/* Tax */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box>GST(this.state.gstPer)</Box>
                <Box>{this.state.gst}</Box>
              </Box>
              {/* Total */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  backgroundColor: Colors.rootBgColor,
                  padding: "10px",
                }}
              >
                <Box>Total</Box>
                <Box>
                  {this.state.total}
                  {/* rupee currency symbol    */}
                  <span>&#8377;</span>
                </Box>
              </Box>

              {/* Paid by dropdown */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Box>Paid by</Box>
                <Box>
                  <select
                    className="form-control"
                    value={this.state.paidBy}
                    onChange={(e) => {
                      this.setState({
                        paidBy: e.target.value,
                      });
                    }}
                  >
                    <option value="cash">Cash</option>
                    <option value="card">Card</option>
                    <option value="wallet">Wallet</option>
                  </select>
                </Box>
              </Box>

              {/* Check in checkout date time picker*/}

              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Box>Check in</Box>
                <Box>
                  <input
                    type="datetime-local"
                    className="form-control"
                    selected={this.state.checkInDate}
                    onChange={(e) => {
                      this.setState({
                        checkInDate: e.target.value,
                      });
                    }}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm aa"
                  />
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Box>Check Out</Box>
                <Box>
                  <input
                    type="datetime-local"
                    className="form-control"
                    selected={this.state.checkOutDate}
                    onChange={(e) => {
                      this.setState({
                        checkOutDate: e.target.value,
                      });
                    }}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm aa"
                  />
                </Box>
              </Box>

              {/* total time span using momentjs */}
              {/* <Box
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginTop: "10px",
                                }}
                            >
                                <Box>Total Time</Box>
                                <Box>
                                    {moment
                                        .duration(
                                            this.state.checkOutDate -
                                                this.state.checkInDate
                                        )
                                        .asHours()
                                        .toFixed(2)}
                                </Box>
                            </Box> */}

              {/* buttons */}

              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    this.setState({
                      cart: [],
                    });
                  }}
                >
                  <i className="fa fa-trash"></i>
                  Clear
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    this.saveOrder();
                  }}
                >
                  <i className="fa fa-save"></i>
                  Save
                </button>

                <button
                  className="btn btn-warning"
                  onClick={() => {
                    this.printKot();
                  }}
                >
                  <i className="fa fa-print"></i>
                  KOT
                </button>

                <button
                  className="btn btn-success"
                  onClick={() => {
                    this.printKot(true);
                  }}
                >
                  <i className="fa fa-print"></i>
                  Print
                </button>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* {this.state.kotPrintInProgress && this.renderKot()}
        {this.state.billPrintInProgress && this.renderBill()} */}
         <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
      </Box>
      
    );
  }
}

export default redux(DineInScreen);
